export default {
    'searchList': {
        'searchTxt': [{
            'name': '服务平台',
            'value': 'dispatchNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        }, {
            'name': '客户',
            'value': 'dispatchNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        }, {
            'name': '订单创建日期',
            'value': 'createTime',
            'startTime': 'beginDate',
            'endTime': 'endDate',
            'startPlaceholder': '创建开始日期',
            'endPlaceholder': '创建结束日期',
            'type': 'time',
            'unfold': true,
            'span': 7
        }],
        'unfoldState': false,
        'advancedBtn': false
    },
    'table':
    {
        'clickState': false,
        'selectBtn': true,
        'height': 400,
        'columns': [
            {
                'label': '分公司',
                'prop': 'dispatchNo',
                'width': '148px'
            },
            {
                'label': '服务平台',
                'prop': 'siteName',
                'width': '100px'
            },
            {
                'label': '承运商',
                'prop': 'senderProvinceName',
                'width': '86px'
            },
            {
                'label': '客户',
                'prop': 'senderCityName',
                'width': '86px'
            },
            {
                'label': '累计未调车',
                'prop': 'senderDistrictName',
                'width': '86px'
            },
            {
                'label': '已调车未到车',
                'prop': 'receiverProvinceName',
                'width': '86px'
            },
            {
                'label': '已装车未发车确认',
                'prop': 'receiverCityName',
                'width': '88px'
            },
            {
                'label': '当日下达量',
                'prop': 'receiverDistrictName',
                'width': '86px'
            },
            {
                'label': '当日调车量',
                'prop': 'driver',
                'width': '70px'
            },
            {
                'label': '当日到车量',
                'prop': 'driverContactWay',
                'width': '102px'
            },
            {
                'label': '当日出库量',
                'prop': 'vehicleCard',
                'width': '82px'
            },
            {
                'label': '当日发车量',
                'prop': 'vehicleCard',
                'width': '82px'
            },
            {
                'label': '当月下达量',
                'prop': 'vehicleCard',
                'width': '82px'
            },
            {
                'label': '当月调车量',
                'prop': 'vehicleCard',
                'width': '82px'
            },
            {
                'label': '当月到车量',
                'prop': 'vehicleCard',
                'width': '82px'
            },
            {
                'label': '当月出库量',
                'prop': 'vehicleCard',
                'width': '82px'
            },
            {
                'label': '当月发车量',
                'prop': 'vehicleCard',
                'width': '82px'
            },
            {
                'label': '承运商代码',
                'prop': 'vehicleCard',
                'width': '82px'
            }],
        'action': [
            {
                'type': 'text',
                'label': '编辑',
                'size': 'mini',
                'event': 'edit'
            }
        ],
        'leftOperation': true
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10,
        'pageSizes': [10, 20, 30, 50, 100] // eslint-disable-line
    }
};
